import {observer} from "mobx-react-lite"
import React, {useEffect} from "react"
import entityCompareController from "./EntityCompareController"
import {AsyncEntitySelection} from "../../components/AsyncEntitySelection"
import {Link, match} from "react-router-dom";
// import {TaskControls} from "../../components/task_buttons/TaskControls";
import CliApi from "../../api/CliApi";
import {appPages} from "../../App";
import {LongActionControls} from "../../components/task_buttons/LongActionControls";
import DictionaryApi from "../../api/DictionaryApi"


const ValueCompareComponent = observer(({match}: { match: match<{ category_id: string, attribute_id: string }> }) => {
    const category_id = match.params.category_id
    const attribute_id = match.params.attribute_id
    useEffect(() => {
        entityCompareController.loadFeatureAndAttributePairs({category_id, attribute_id})
    }, [category_id, attribute_id])

    return <div>
        <h5>Сопоставление значений</h5>
        <div>
            <Link className={"underline gray"}
                  to={appPages.offerAttributes + '/category/' + category_id}>
                <i className="fa fa-angle-left"/> К списку характеристик
            </Link>
        </div>

        <div className={"custom-my-20"}>
            <LongActionControls
                command={{type: "", command: ""}}
                hideInput={true}
                start={() => DictionaryApi.runDownloadDictionary({category_id, attribute_id})}
                onEnd={() => {
                    entityCompareController.loadFeatureAndAttributePairs({category_id, attribute_id})
                }}
                buttonText={() => <>Загрузить значения Ozon</>}
                action={"backend&action=dictionariesDownload"}
                saveAction = {() => entityCompareController.saveEntities()}
            />
        </div>

        {entityCompareController.entitiesLoaded && <div>
            {entityCompareController.entities.map((pair, index) => <table key={index}>
                <thead style={{backgroundColor: "#F3F3F3"}}>
                <tr>
                    <th>Значение "{entityCompareController.name}" в Shop-Script</th>
                    <th/>
                    <th>Значение "{entityCompareController.attribute_name}" в Ozon</th>
                </tr>
                </thead>
                <tbody>
                {pair.entities.map((entity, index) => (<tr key={index}>
                        <td className="custom-px-0">{entity.feature_value}</td>
                        <td><i className="fa fa-angle-right gray" aria-hidden="true"/></td>
                        <td><AsyncEntitySelection entity={entity}/></td>
                    </tr>)
                )}
                </tbody>
            </table>)}
            {(entityCompareController.entities.length > 20) && <button className={'button green ozon_save'} onClick={entityCompareController.saveEntities}>Сохранить</button>}
        </div>}
    </div>
})

export default ValueCompareComponent